import { styled } from '@abyss/web/tools/styled';
import { Box } from '@abyss/web/ui/Box';
import { Flex } from '@abyss/web/ui/Flex';
import { Heading } from '@abyss/web/ui/Heading';

import { useRouter } from 'next/compat/router';
import { Button } from '@pass-frontend/abyss/common/components/button/ui';
import { ContentWidthWrapper } from '@pass-frontend/abyss/common/components/content-width-wrapper/ui';
import { MEDIA_QUERY } from '@pass-frontend/abyss/utility/style-helpers';
import {
  EventType,
  getPageName,
  logAnalyticsEvent,
} from '@pass-frontend/common/analytics';
import { getRegistrationUrl } from '@pass-frontend/common/constants/paths';
import { useIntl } from '@pass-frontend/common/i18n';

const StyledWrapper = styled(Flex, {
  padding: '$lg 0',

  [MEDIA_QUERY.desktop]: {
    padding: '64px 0',
  },
});

const StyledButton = styled(Button, {
  [MEDIA_QUERY.mobileAndTablet]: {
    width: '100%',
  },
});

const StyledDescription = styled(Heading, {
  marginBottom: '$sm',

  [MEDIA_QUERY.desktop]: {
    marginBottom: '$md',
  },
});

export const FitnessThatGetsYou = () => {
  const { t } = useIntl();
  const router = useRouter();

  const handleButtonClick = (event: any) => {
    logAnalyticsEvent(
      EventType.PageNav,
      {
        pageName: getPageName(router?.pathname),
      },
      event.nativeEvent,
    );
    router?.push(getRegistrationUrl(router?.locale));
  };

  return (
    <Box color="$tint1" padding="0">
      <ContentWidthWrapper>
        <StyledWrapper justify="center">
          <Flex
            direction="column"
            alignItems="center"
            css={{ maxWidth: '840px', gap: '$md' }}
          >
            <Heading offset={1} textAlign="center">
              {t('fitnessThatGetsYou.heading')}
            </Heading>
            <StyledDescription offset={5} color="$gray7" textAlign="center">
              {t('fitnessThatGetsYou.description')}
            </StyledDescription>
            <StyledButton
              onClick={handleButtonClick}
              data-ui-element-name="Get Started"
            >
              {t('fitnessThatGetsYou.cta')}
            </StyledButton>
          </Flex>
        </StyledWrapper>
      </ContentWidthWrapper>
    </Box>
  );
};
